import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_toolbar, {
      height: "150",
      color: "primary"
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          src: _ctx.logo,
          width: "223"
        }, null, 8, _hoisted_1)
      ]),
      _: 1
    }),
    _createVNode(_component_v_card, {
      width: "500",
      class: "ma-auto"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_toolbar, {
          color: "var(--varv-lisa-2)",
          title: "Teie Kriminaalhooldusportaali sessioon on aegunud!"
        }),
        _createVNode(_component_v_card_text, { class: "text-center ma-3" }, {
          default: _withCtx(() => [
            _createTextVNode(" Turvaliseks väljumiseks tuleb sulgeda brauseri aken! ")
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_actions, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_btn, {
              class: "mx-3 mb-3",
              variant: "elevated",
              color: "primary",
              onClick: _ctx.logiValja
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Välju ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}